export enum LineColor {
  Green = '#91cc75',
  Yellow = '#fac858',
  Blue = '#5470c6',
  Red = '#ee6666',
}
